import { TextFieldProps } from '@mui/material';
import { CompanyTypes } from 'api/types/ReferenceDataTS';
import { SegmentTag } from 'types/global';

export type RegistrationPageFormState = {
  email: string;
  companyKey: string | undefined;
  company: string;
  companyNote: string;
  companyType: CompanyTypes | '';
  firstName: string;
  lastName: string;
  function: string;
  segments: SegmentTag[];
  notifications: { covalo_digest_enabled: boolean };
  title: string;
  country: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  tosChecked: boolean;
};

export const DEFAULT_FORM_VALUES: RegistrationPageFormState = {
  password: '',
  confirmPassword: '',
  email: '',
  companyKey: undefined,
  companyType: '',
  notifications: { covalo_digest_enabled: false },
  segments: [],
  company: '',
  companyNote: '',
  firstName: '',
  lastName: '',
  function: '',
  title: '',
  country: '',
  phoneNumber: '',
  tosChecked: false
};
export enum RegistrationPageMode {
  EMAIL_UNCLEAR = 'EMAIL_UNCLEAR',
  EMAIL_EXISTS_BRANDPORTAL = 'EMAIL_EXISTS_BRANDPORTAL',
  EMAIL_EXISTS_COVALO = 'EMAIL_EXISTS_COVALO', //brand portal specific
  COMPANY_NO_MATCH = 'COMPANY_NO_MATCH', // there is no company matching the email domain
  COMPANY_MATCH = 'COMPANY_MATCH', // there is a company matching the email domain
  COMPANY_REJECTED_MATCH = 'COMPANY_REJECTED_MATCH', // there is a company matching the email domain, but the user wants a different
  SUCCESS = 'SUCCESS'
}
export const DEFAULT_FIELD_PROPS: TextFieldProps = {
  fullWidth: true,
  margin: 'dense'
};
